export default "__VITE_ASSET__eddd2cb3__"